import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css'
import ReactDOM from 'react-dom/client';
import './index.css';  
import Home from './pages/home';
import About from './pages/aboutUs'
import Contact from './pages/contactUs';
import Properties from './pages/properties'
import Services from './pages/services'
import SpringDetail from './pages/SpringDetail.jsx';
import ErrorPage from './pages/ErrorPage';
import PropertyDetails from './pages/propertyDetails.jsx';
import PrimeEstateDetail from './pages/primeEstateDetail.jsx';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import SpringPhase2 from './pages/SpringPhase2.jsx';
import RoseDetail from './pages/RoseDetail.jsx';
import LuxuryDetail from './pages/LuxuryDetail.jsx';

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <ErrorPage/>,
     children: [
      {index: true, element: <Home/>},
      {path: "about", element: <About/>},
      {path: "properties", element: <Properties/>},
      {path: "contact_us", element: <Contact/>},
      {path: "services", element: <Services/>},
      {path: "/premium_estate_detail", element: <PropertyDetails/>},
      {path: "/prime_estate_detail", element: <PrimeEstateDetail/>},
      {path: "/spring_view_estate_detail", element: <SpringDetail/>},
      {path: "/spring_view_estate_phase_II_detail", element: <SpringPhase2/>},
      {path: "/rose_estate_detail", element: <RoseDetail/>},
      {path: "/luxury_court_detail", element: <LuxuryDetail/>},
     ]
  }
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);
